import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class AddUserFavoriteUseCase extends UseCase {
  constructor({repository, userNotLoggedInError, getCurrentUserService}) {
    super()
    this._repository = repository
    this._userNotLoggedInError = userNotLoggedInError
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'AddUserFavoriteUseCase#execute'})
  @inlineError
  async execute({adId, filteredProvinces = 'unknown'}) {
    try {
      const userEntity = await this._getCurrentUserService.execute()
      const userId = userEntity.getId()

      return this._repository.add({
        adId,
        filteredProvinces,
        userId
      })
    } catch (e) {
      throw this._userNotLoggedInError('[AddUserFavoriteUseCase#execute] User is not logged in')
    }
  }
}

export default AddUserFavoriteUseCase
